import { formatDateReadable } from '@nemuru-eng/js-api-client';

import { Text } from '../../../../../../shared/components/Text';

export const reportDateFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.35,
    field: 'report_date',
    headerName: <Text tId={'REPORT_DATE'} />,
    align: 'left',
    searchable: false,
    defaultSort: 'desc',
    renderCell: (rowData) => {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          {formatDateReadable(rowData.row.reportDate)}
        </div>
      );
    },
  };
};
